import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { IDataEntry } from '../../features/data-entry/viewmodels/data-entry.viewmodel';

@Pipe({
  name: 'reportingPeriod',
  standalone: true,
  pure: true,
})
export class ReportingPeriodPipe implements PipeTransform {
  private datePipe: DatePipe = new DatePipe('en-US');
  transform(
    dataEntry: IDataEntry | undefined,
    reportingPeriod: 'week' | 'due' | 'completed' = 'week'
  ): string {
    if (!dataEntry) {
      return '';
    }

    // Format dates as MMMM d
    const format = 'MMMM d';
    const formatDate = (d: Date) => {
      return this.datePipe.transform(d, format) ?? 'unknown';
    };

    if (reportingPeriod === 'due') {
      return formatDate(dataEntry.dateDue);
    }
    if (reportingPeriod === 'completed' && dataEntry.completedOn) {
      return formatDate(dataEntry.completedOn);
    }

    return `${formatDate(dataEntry.datePeriodStart)}–${formatDate(
      dataEntry.datePeriodEnd
    )}`;
  }
}
